var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconKeyboardArrowRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.45765 4.47126C5.86995 3.92519 5.84741 3.01786 6.40732 2.44468C6.96722 1.87151 7.89753 1.84953 8.48523 2.3956C8.48523 2.3956 17.5544 10.953 17.5791 10.9778C18.1587 11.5692 18.137 12.5068 17.5307 13.072L8.48532 21.6027C7.89855 22.1498 6.9682 22.1293 6.40732 21.5571C5.84643 20.9848 5.86741 20.0774 6.45417 19.5304L14.0917 12.2029C14.2066 12.0927 14.2066 11.909 14.0918 11.7988L6.45765 4.47126Z",
    fill: "#878793"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconKeyboardArrowRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-keyboard-arrow-right.55b6f671086d7ffef1d52fddd1666b54.svg";